var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortAscend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 19.564 19.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "PTdLni.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.959,2.737v.213c0,5.074,0,10.148,0,15.222,0,.477-.217.781-.618.87-.408.09-.828-.182-.903-.593-.022-.119-.026-.242-.026-.363-.001-5.037-.001-10.075-.001-15.112v-.283c-.081.076-.128.118-.172.163-.373.376-.74.759-1.12,1.129-.456.444-1.121.313-1.318-.259-.11-.318-.016-.594.223-.83.679-.674,1.353-1.352,2.03-2.027.056-.056.118-.106.179-.155.562-.453,1.424-.459,1.949.037.756.716,1.488,1.458,2.216,2.203.311.318.288.789-.014,1.083-.298.29-.768.288-1.086-.02-.389-.377-.769-.764-1.151-1.149-.047-.047-.082-.107-.122-.16-.021.011-.043.022-.064.033Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.146,7.372c-1.657,0-3.314,0-4.971,0-.445,0-.745-.225-.835-.616-.093-.406.179-.827.59-.906.095-.018.193-.026.29-.026,3.29-.001,6.58-.001,9.87,0,.484,0,.788.212.879.608.107.467-.223.895-.724.937-.061.005-.122.003-.183.003-1.639,0-3.278,0-4.917,0Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.994,9.725c1.267,0,2.534,0,3.802,0,.452,0,.755.232.839.634.083.397-.195.816-.594.888-.095.017-.194.026-.29.026-2.51.001-5.02.001-7.53,0-.474,0-.778-.207-.875-.59-.129-.51.244-.955.811-.957.92-.004,1.84-.001,2.76-.001.359,0,.719,0,1.078,0Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.795,15.16c-.907,0-1.814.002-2.721-.001-.399-.001-.703-.289-.754-.7-.042-.339.211-.704.56-.801.063-.018.131-.024.197-.024,1.826-.001,3.652-.002,5.478,0,.393,0,.691.277.752.682.051.338-.192.711-.54.814-.091.027-.192.029-.288.029-.895.002-1.79.001-2.684.001h0Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.652,19.067c-.506,0-1.011.004-1.517-.001-.416-.004-.71-.237-.796-.618-.092-.405.183-.826.594-.903.089-.017.181-.025.272-.026.963-.002,1.925-.002,2.888,0,.459,0,.762.214.855.593.121.497-.239.944-.778.953-.506.008-1.011.002-1.517.002Z",
    fill: "#666"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscend);
export default __webpack_public_path__ + "static/media/sort-ascend.3dd619ea.svg";
export { ForwardRef as ReactComponent };